export enum VisaCheckoutClientStatus {
  SUCCESS = "VISA_CHECKOUT_STATUS_SUCCESS",
  SUCCESS_FAILED = "VISA_CHECKOUT_STATUS_SUCCESS_FAILED",
  CANCEL = "VISA_CHECKOUT_STATUS_CANCEL",
  ERROR = "VISA_CHECKOUT_STATUS_ERROR",
  PRE_PAYMENT = "VISA_CHECKOUT_STATUS_USER_DATA_PREFILL",
}
